import Vue from "vue";
import Vuex from "vuex"; 

Vue.use(Vuex);
const ADD_TOKEN = 'ADD_TOKEN';
const REMOVE_TOKEN = 'REMOVE_TOKEN';
const ADD_STUDENTID = 'ADD_STUDENTID';
const DEL_STUDENTID = 'DEL_STUDENTID';
export default new Vuex.Store({
  state: {
    token: '',
    studentId:'',
    
  },
  mutations: {
    [ADD_TOKEN](state, token) {
      state.token = token;
      // state.token = sessionStorage.getItem('token');
    },
    [REMOVE_TOKEN](state, token) {
      sessionStorage.removeItem('token_retire_school')
      state.token = '';
    },
    [ADD_STUDENTID](state, studentId){
      state.studentId = studentId;
      // state.studentId =  sessionStorage.getItem('studentId');
    },
    [DEL_STUDENTID](state, studentId){
      state.studentId =  studentId;
      sessionStorage.removeItem('studentId')
    },
     
  },
  actions: {}
});
